export default "__VITE_ASSET__f55a2b39__"